import {districts} from "../../../../SiteConfig/districtsMockData";
import {OWN_LOAN_STATUS} from "./ownLoanConstants";
import {getLoanOwnStatusTextByValue} from "./ownLoanUtility";

export const ownLoanMockData = [
    {
        loanOwnItemId: "15560759-503c-4d49-a377-94859c0ae290",
        dateRequested: "03/01/2024",
        dateProcessed: "03/05/2024",
        title: "OWN Book Title 1",
        ownOrderNumber: "OWN123456",
        runningCost: 150,
        patron: "Alice Johnson",
        districtName: districts[0].districtName,
        organization: "rmtc",
        shippingLocation: "Main Library",
        catalogNumber: "CAT001",
        loanStatus: OWN_LOAN_STATUS.InReview,
        loanStatusText: getLoanOwnStatusTextByValue(OWN_LOAN_STATUS.InReview.toString()),
        shippingLocationId: "07a4b8d0-51fa-4616-80b3-6b4ab116a973",
        shippingLocationName: "A D HENDERSON UNIVERSITY SCHOOL ",
        shippingLocationDetails : {
            "shippingLocationId": "9aa32023-7b38-48b7-b4ef-a0567c3539b9",
            "userId": "f9a1b719-15cb-4fb6-94df-5cf1ef34bfbe",
            "districtId": "f4a05ab5-bbfd-4f4e-2f36-08dd8d8ece65",
            "isActive": true,
            "name": "HIALEAH MIDDLE SCHOOL",
            "address": "6027 E 7TH AVENUE",
            "address2": " ",
            "city": "HIALEAH",
            "state": "FL",
            "zipCode": "33013-1127"
        }
    },
];
